import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import Pagination from "../../components/Pagination/Pagination";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

import {
  ProjectDropdown,
  FetchOrderPickingList,
  AddOrderPicking,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { ADD_ORDER_PICKING } from "../../redux/constants/type";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";

const ProjectOrderPickingList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const Project_Popup_Ref = useRef(null);
  const Project_Item_Popup_Ref = useRef(null);
  const filter_Popup_Ref = useRef(null);
  const Sortby_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");

  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown
  );

  const addOrderPickingRes = useSelector(
    (state) => state.user.addOrderPickingRes
  );

  const fetchOrderPickingListRes = useSelector(
    (state) => state.user.fetchOrderPickingListRes
  );

  // variables start

  // asc cancel popup start //
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    // history.push("/InvoiceAllList");
    history.goBack();
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  // asc cancel popup end //

  const [apimessage, setApimessage] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [projectName, setProjectName] = useState("");
  const [projectItemName, setProjectItemName] = useState("");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const [filtersPopupShow, setFiltersPopupShow] = useState(false);

  const [listData, setListData] = useState([]);
  const [productPartID, setProductPartID] = useState("");
  const [projectData, setProjectData] = useState([]);
  const [projectid, setProjectid] = useState("");
  const [projectItemId, setProjectItemId] = useState("");
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [projectItemShowOptions, setProjectItemShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [arrowItemOptionsRotate, setArrowItemOptionsRotate] = useState(false);

  const [listHover, setListHover] = useState(false);
  const [asc_ProductPartid, setAsc_ProductPartid] = useState("");
  const [asc_Itemdescription, setAsc_Itemdescription] = useState("");

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("ItemName");

  const [productandPartValue, setProductandPartValue] = useState("");

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  useEffect(() => {
    dispatch(ProjectDropdown());
  }, []);

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `${sortedValue}ByAscending`
      : `${sortedValue}ByDescending`;

    const filterdPayload = productandPartValue ? productandPartValue : "All";

    if (querystring) {
      // dispatch(FetchOrderPickingList(companyId, "", querystring));
      dispatch(
        FetchOrderPickingList(companyId, "", filterdPayload, querystring, 0, 0)
      );
    } else {
      dispatch(
        FetchOrderPickingList(
          companyId,
          sortedPayload,
          filterdPayload,
          querystring,
          0,
          0
        )
      );
    }
  }, [dispatch, shortByArrow, sortedValue, productandPartValue, querystring]);

  useEffect(() => {
    fetchScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);
  // const screenSize = useScreenSize();

  // order picking list res start
  useEffect(() => {
    if (fetchOrderPickingListRes?.status === true) {
      // let defaultQty =
      //   fetchOrderPickingListRes.data?.map((x) => ({
      //     ...x,
      //     qtyToPick: x.stock,
      //   })) || [];
      setListData(fetchOrderPickingListRes.data);
      setTotalPages(Math.ceil(fetchOrderPickingListRes.data.length / perPage));
    }
  }, [fetchOrderPickingListRes, perPage]);
  // order picking list res end

  // project dropDown res start
  useEffect(() => {
    if (fetchProjectDropdown?.status === true) {
      setProjectData(fetchProjectDropdown?.data);
    }
  }, [fetchProjectDropdown]);
  // project dropDown res end

  // add order picking api res start
  useEffect(() => {
    if (addOrderPickingRes?.status === true) {
      // setProjectData(addOrderPickingRes?.data);
      // setApimessage("Added successfully");
      setProjectName("");
      setProjectItemName("");
      setProjectid("");
      setProjectItemId("");
      setListData([]);

      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: ` Great Job! The product was picked for the project.`,
        },
        false
      );

      const sortedPayload = shortByArrow
        ? `${sortedValue}ByAscending`
        : `${sortedValue}ByDescending`;

      const filterdPayload = productandPartValue ? productandPartValue : "All";

      dispatch(
        FetchOrderPickingList(
          companyId,
          sortedPayload,
          filterdPayload,
          querystring,
          0,
          0
        )
      );

      setTimeout(() => {
        setApimessage("");
        // history.goBack();
      }, 2000);

      dispatch({
        type: ADD_ORDER_PICKING,
        data: {},
      });
    } else {
      // setInvoiceList([]);

      if (addOrderPickingRes.status === false) {
        setApimessage("Something went Wrong");
        setTimeout(() => {
          setApimessage("");
        }, 3000);
      }
    }
  }, [addOrderPickingRes]);
  // add order picking api res end

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      Project_Item_Popup_Ref.current &&
      !Project_Item_Popup_Ref.current.contains(event.target)
    ) {
      setProjectItemShowOptions(false);
      setArrowItemOptionsRotate(false);
    }

    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setFiltersPopupShow(false);
    }

    if (
      Sortby_Popup_Ref.current &&
      !Sortby_Popup_Ref.current.contains(event.target)
    ) {
      setShowShortDrop(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const handleOrderPicking = () => {
    // const newArray = [];
    // for (let index = 0; index < orderProductArray.length; index++) {
    //   newArray.push({
    //     productid: orderProductArray[index].asc_ProductPartid,
    //     qty: orderProductArray[index].asc_Qty
    //       ? orderProductArray[index].asc_Qty
    //       : 0,
    //   });
    // }

    let payload = listData
      .filter((x) => x.isCheck)
      .map((x) => ({
        productid: x.productPartid,
        orderproductqty: x.qtyToPick,
      }));

    dispatch(AddOrderPicking(projectid, "", payload));
  };

  // sort by start
  const sortByOption = [
    { label: "Item Name", value: "ItemName" },
    { label: "Item ID", value: "ItemCode" },
    // { label: "Client", value: "Client" },
    { label: "Aisle", value: "Aisle" },
    { label: "Row", value: "Row" },
    { label: "Bin", value: "Bin" },
  ];
  // sort by end

  document.getElementById("asc_input")?.focus();

  const handleQtyToPickChange = (e, index) => {
    const { value } = e.target;
    let oldData = [...listData];
    let newValue = Number(value);
    let instock = Number(oldData[index].stock);
    oldData[index]["qtyToPick"] =
      newValue > 0 ? Math.min(newValue, instock) : 0;

    // Automatically check the checkbox when typing in qtyToPick
    if (!oldData[index].isCheck) {
      oldData[index]["isCheck"] = true;
      setProductPartID(oldData[index].productPartid);
    }
    setListData(oldData);
    setTypeInScreen("asc");
    setProductPartID("");
  };

  // asc for disable Add Button start.
  let disableData = listData.some((x) => x.qtyToPick);
  // asc for disable Add Button end.

  return (
    <mainSection>
      <Header
        setQuery={setQuerystring}
        leftComponent={
          <div className="stock-heading-box">
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              Stock
            </div>
            <div className="confirm-box-title w-100 gap-1">
              <div className="opacity-1">Order Picking |</div>
              <div className="stock-order-id">
                ID {"23.1064 Façade painting"}
              </div>
            </div>
          </div>
        }
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeInScreen !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // if (typeInScreen !== "") {
          //   if (
          //     !["/stock"].includes(location.pathname)
          //   ) {
          //     return true;
          //   }
          // }
          return false;
        }}
      />

      <headerSection>
        <div className="ps-5 d-flex justify-content-between align-items-center">
          <div className="d-flex gap-5 justify-content-around ">
            <div className="d-flex gap-3 ">
              <div className="stock-order-id">Work</div>
              <b>Phase 01</b>
            </div>
            <div className="d-flex gap-3 ms-5">
              <div className="stock-order-id">List</div>
              <b>546.00</b>
            </div>
          </div>
          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  // history.goBack();
                  history.push("/stock");
                }
              }}
            >
              Cancel
            </button>

            <button
              className="mb-0 makeInvoBtn"
              disabled={
                projectName === "" ||
                projectItemName === "" ||
                disableData === false
              }
              onClick={() => {
                handleOrderPicking();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </headerSection>

      <tableSection>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px" }}
          >
            <table className="table">
              <thead>
                <tr className="tableHeading-NewInvoice">
                  <th className="ps-5" style={{ width: "35%" }}>
                    {/* {FetchTranslationList[30]?.translation} */}
                    Item Name
                  </th>
                  <th style={{ width: "15%" }}>
                    {t("Item Id")}
                  </th>
                  <th style={{ width: "15%" }}>
                    Kg
                    {/* {FetchTranslationList[19]?.translation} */}
                  </th>
                  <th style={{ width: "15%" }}>
                    {t("In Stock")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Aisle")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Row")}
                  </th>
                  <th style={{ width: "10%" }}>
                    {t("Bin")}
                  </th>
                  <th className="text-end pe-4">
                    {t("Qty to Pick")}
                  </th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {listData
                  .slice(currentPage * perPage, (currentPage + 1) * perPage)
                  .map((item, index) => {
                    return (
                      <tr key={index} className="TableRowClass bg-transparent">
                        <td>
                          <div
                            className="d-flex gap-4 ps-2"
                            style={{ position: "relative" }}
                          >
                            <input
                              class="form-check-input pointer"
                              type="checkbox"
                              id="ascInvoice"
                              checked={item.isCheck ? true : false}
                              onClick={(e) => {
                                // setProductPartID(item.productPartid);
                                let data = [...listData];
                                let productIndex = data.findIndex(
                                  (arg) =>
                                    arg.productPartid === item.productPartid,
                                );
                                data[productIndex]["isCheck"] =
                                  e.target.checked;
                                setListData(data);
                              }}
                            />
                            <textHoverSection>
                              {listHover &&
                                asc_ProductPartid === item.productPartid &&
                                item.itemdescription.length > 30 && (
                                  <div className="textHoverSection">
                                    <h6>
                                      {item.itemdescription.length > 30 &&
                                        asc_Itemdescription}
                                    </h6>
                                  </div>
                                )}
                            </textHoverSection>
                            <p
                              onMouseEnter={() => {
                                setListHover(true);
                                setAsc_ProductPartid(item.productPartid);
                                setAsc_Itemdescription(item.itemdescription);
                              }}
                              onMouseLeave={() => {
                                setListHover(false);
                                setAsc_ProductPartid("");
                                setAsc_Itemdescription("");
                              }}
                            >
                              {item.itemdescription.length > 30
                                ? item.itemdescription.slice(0, 30) + "..."
                                : item.itemdescription}
                            </p>
                          </div>
                        </td>

                        <td>{item.productPartCode}</td>

                        <td>
                          <div className="colorArray">
                            {item.colorcode.map((color) => {
                              return (
                                <div
                                  className="asc_Color_Code"
                                  style={{ background: color.color }}
                                ></div>
                              );
                            })}
                          </div>
                        </td>
                        <td>{item.stock}</td>
                        <td>{item.aisle}</td>
                        <td>{item.row}</td>
                        <td>{item.bin}</td>
                        <td
                          className="text-end pe-4"
                          style={{
                            background: "#FAFAFA",
                          }}
                        >
                          <input
                            className={
                              item.isCheck
                                ? "highlightedInput text-end"
                                : "orderPickInput text-end"
                            }
                            // id={
                            //   productPartID === item.productPartid &&
                            //   "asc_input"
                            // }
                            type="number"
                            placeholder="0"
                            value={item.qtyToPick ? item.qtyToPick : 0}
                            // onChange={(e) => handleQtyToPickChange(e, index)}
                            onChange={(e) => {
                              if (item.stock > 0) {
                                let data = [...listData];
                                let productIndex = data.findIndex(
                                  (arg) =>
                                    arg.productPartid === item.productPartid,
                                );
                                data[productIndex]["qtyToPick"] =
                                  +e.target.value;
                                data[productIndex]["isCheck"] = true;
                                setListData(data);
                              }
                            }}
                          />
                        </td>
                        {/* <td>{europeanFormatWithSymbol(item.asc_Total)}</td> */}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          {listData.length > 0 && (
            <div className="mx-5">
              <Pagination
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
              />
            </div>
          )}
        </section>
      </tableSection>
    </mainSection>
  );
};

export default ProjectOrderPickingList;
